import { Component, OnInit, ViewEncapsulation, ViewChild, Input } from '@angular/core';
import {Router} from '@angular/router';
import { NgForm } from '@angular/forms';
import { WebService } from 'src/app/shared/services/web.service';
import { SecureLocalStorage } from 'src/app/shared/services/secure-local-storage';
import { local } from 'd3';
import { MenuItems } from '../../core/menu/menu-items/menu-items';
import { EnvironmentUrlService } from '../../shared/services/environment-url.service';
declare var $: any, bootbox: any;
@Component({
  selector: 'app-login-session',
  templateUrl: './login-component.html',
  styleUrls: ['./login-component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class LoginComponent {
  email: string;
  password: string;
  button: boolean = false;
  Genratebutton: boolean = true;
  Apiurl = '';
  searchLoginObj = new LoginObject();
searchObj1 = new LoginObject(); 								  
  @ViewChild('loginForm') loginForm: NgForm;
  validation: boolean = false;
  otpvalidation: boolean = false;
  @ViewChild('verifyForm') verifyForm: NgForm;
  showPassword: boolean = false;
  showOTP: boolean = true;
  OtpShow: boolean = false;
  accountLists = [];
  isLogin: boolean = false;
  checkLoginAttempt: number = 0;
  enableLoginbutton: boolean = false;
  isTATExpired: boolean = false;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';
  public siteKey: any;						 														
  public encryptInfo;
  public decryptedInfo;
  constructor(
    private router: Router, private webService: WebService, private secureLS: SecureLocalStorage, public menuItems: MenuItems, public _service: EnvironmentUrlService
  ) {
    localStorage.clear();
    this.secureLS.removeStorage();
  }

  ngOnInit() {
    debugger;
    //this.searchLoginObj.Loginname = localStorage.getItem('Email');
    //localStorage.clear();
    //this.secureLS.removeStorage();
	this.siteKey = this._service.siteKey;
    setTimeout(() => { $('#newsTicker1').breakingNews(); }, 500)
    this.noBack();

 
	}
   noBack() {
      window.history.forward()
  }


  loginWithChange(event) {
    debugger;
    if(event === 'password') {
      this.validation = false;
      this.showOTP = false;
      this.showPassword = true;
    }else{
      this.showPassword = false;
      if(this.loginForm.value.Loginname != undefined) {
        this.Apiurl = "api/OtpGenerate/SendOtpOnlogin";
        /** Secure Post Data - Atul Joshi */
        let loginWithChangeData = {
          "Loginname": this.webService.encryptData(this.searchLoginObj.Loginname),
          "EkycClientcode": this.webService.encryptData(this.searchLoginObj.EkycClientcode),
        };
        this.webService.postData(this.Apiurl, loginWithChangeData).subscribe((data: any) => {
          if (data.statusCode == "200") {
            this.showOTP = true;
            
            bootbox.alert({
              message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>OTP have been sent successfully to your given input, Please verify OTP</h6></div>",
              size: 'large'
            });
          }
          else if (data.statusCode == "204") {
            bootbox.alert({
              message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Invalid user-id or password information entered, Please correct and re-enter.</h6></div>",
              size: 'large'
            });
          }
        })
      }else{
        this.validation = true;
      }
    }
  }
  
  login() {
    
    if (!this.loginForm.valid) {
      this.validation = true;
    }
    else {
      console.log(this.searchLoginObj.Loginname, this.searchLoginObj.Password)
      this.Apiurl = "api/Authenticate/login";
      /** Secure Post Data - Atul Joshi */
      let loginData = {
        "Loginname": this.webService.encryptData(this.searchLoginObj.Loginname),
        "EkycClientcode": this.webService.encryptData(this.searchLoginObj.EkycClientcode),
        "Password": this.webService.encryptData(this.searchLoginObj.Password)
      };
      
      this.webService.postData(this.Apiurl, loginData).subscribe((data: any) => {
        
        //const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
        //console.log("RkTest1", time_to_login)
       /*this.secureLS.setStorage('timer', JSON.stringify(time_to_login));*/
        if (data.status == "1") {
          console.log("RK", data)
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>You Have Successfully Login As A RM</h6></div>",
            size: 'large'
          });
          
          
          this.secureLS.setStorage('RMTk', data);
          this.router.navigate(['dashboard/RmDashboard']);
          

        }
        else if (data.statusCode == "200") {
          debugger;
          console.log(data);
          this.secureLS.setStorage('LoginUserData', data);
          this.secureLS.setStorage('TokenId', data.token);
          //this.button = true;
          this.Genratebutton = false;
          this.searchLoginObj.EkycClientcode = data.ekyc_code;
          
          //if (data.systmPasswordflg == false) {
          //  this.router.navigate(['authentication/lockscreen']);
          //}
          //else {

            this.secureLS.setStorage('MenuList', this.menuItems.getMenuOnclient());
            this.checkClientIdentitySubmitted();

          //}
        }
        else if (data.statusCode == "204") {
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Invalid user-id or password information entered, Please correct and re-enter.</h6></div>",
            size: 'large'
          });
        }
        else if (data.statusCode == "401") {
          bootbox.alert({
            message:  data.message,
            size: 'large'
          });
        }
      }, error => {
        console.log('Error ', error);
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Invalid user-id or password information entered, Please correct and re-enter.</h6></div>",
            size: 'large'
          });
      })
    }
  }
  verfiyOtp() {
    this.getTATDetails();
    if (!this.verifyForm.valid) {
      this.otpvalidation = true;

    }
    else {
      this.Apiurl = "api/OtpGenerate/VerfiyOtpforlogin";
      /** Secure Post Data - Atul Joshi */
      let verifyOTPData = {
        "Loginname": this.webService.encryptData(this.searchLoginObj.Loginname),
        "EkycClientcode": this.webService.encryptData(this.searchLoginObj.EkycClientcode),
        "LoginOtp": this.webService.encryptData(this.searchLoginObj.LoginOtp)
      };
      this.webService.postData(this.Apiurl, verifyOTPData).subscribe((data: any) => {

        if (data.statusCode == 204 || data.statusCode == 401) {
          bootbox.alert(data.message);
          return false;
        }
        else if (data.statusCode == 200) {

          const time_to_login = Date.now();//+ 12 * 3600 * 1000 //15 minutes;
          this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
          this.secureLS.setStorage('LoginUserData', data);
          this.secureLS.setStorage('TokenId', data.token);

          if (this.isTATExpired == false) {
            bootbox.alert({
              message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>Input OTP Received, And You Have Been SignedIn Successfully.</h6></div>",
              size: 'large'
            });

            this.secureLS.setStorage('MenuList', this.menuItems.getMenuOnclient());

            this.checkClientIdentitySubmitted();
          }

          else {
            bootbox.alert("As Per SEBI Guidelines Your TAT Time Period Has Expired, You Have To Reinitiate Account!");
            this.router.navigate(['register']);
          }


        }
      })

    }


  }
  resendotp() {
    
    this.Apiurl = "api/OtpGenerate/resendotp";
    this.webService.postData(this.Apiurl,
      this.searchLoginObj).subscribe((data: any) => {
        if (data.dataset == "Your DigiEkyc account is locked out for 1 Hour.Try login again after some time.") {
          bootbox.alert("Your DigiEkyc account is locked out for 1 Hour.Try login again after some time");
        }
        else {
          if (data.statusCode == 204) {
            bootbox.alert(data.message);
            return false;
          }
          else {
            if (data.statusCode == 200) {
              bootbox.alert({
                message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>OTP have been re-sent successfully to your given input.Please verify OTP</h5></div>",
                size: 'large'
              });
            }
          }
        }


      

      })
  }
checkClientIdentitySubmitted() {
  debugger;
  
  var EkyclientCode = this.webService.encryptData(this.searchLoginObj.EkycClientcode);
  console.log("id", this.searchLoginObj.EkycClientcode);
  let url = "api/Authenticate/CheckClientIdentitySubmitted/" + EkyclientCode;
  this.webService.getData(url).subscribe((res: any) => {
    const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
    this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
    if (res != null) {
      debugger;

      if (res.statusCode == 404) {
        this.router.navigate(['client-basic-details/pan-search']);
      }
      if (res.statusCode == 200) {
        this.router.navigate(['client-basic-details/Client-DashBord']);
      }
      //if (res.statusCode == 201) {
      //  this.router.navigate(['client-account/payment']);
      //}
    }

  }, error => {

  });
}
  SendOtpForVerification() {
    if (this.searchLoginObj.Loginname == undefined) {
      this.validation = true;
      return false;
    }
    this.Apiurl = "api/OtpGenerate/SendOtpOnlogin";
    /** Secure Post Data - Atul Joshi */
    let loginWithChangeData = {
      "Loginname": this.webService.encryptData(this.searchLoginObj.Loginname),
      "EkycClientcode": this.webService.encryptData(this.searchLoginObj.EkycClientcode),
    };
    this.webService.postData(this.Apiurl, loginWithChangeData).subscribe((data: any) => {
      if (data.dataset == "Your DigiEkyc account is locked out for 1 Hour.Try login again after some time.") {
        bootbox.alert("Your DigiEkyc account is locked out for 1 Hour.Try login again after some time");
        this.OtpShow = false;
      }
      else {
        bootbox.alert("Otp send to entered user details.")
        this.OtpShow = true;
        this.searchLoginObj.LoginOtp = null;
      }
    })
  }
  CheckAvailableAccount() {
    if (this.searchLoginObj.Loginname == undefined) {
      this.validation = true;
      return false;
    }
    this.OtpShow = false;
    
    let url = "api/Authenticate/GetLoginDetails";
    this.searchObj1.Loginname = this.webService.encryptData(this.searchLoginObj.Loginname);
    this.searchObj1.LoginOtp = this.searchLoginObj.LoginOtp;
    this.webService.postData(url, this.searchObj1).subscribe((res: any) => {
      debugger;
      if (res.statusCode == '200') {
        this.accountLists = res.dataset;
        this.searchLoginObj.LoginOtp = null;
      }else{
        this.searchLoginObj.LoginOtp = null;
        bootbox.alert(res.message);
        
      }

    }, error => {
      bootbox.alert("<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Record Not Found.</h6></div>");
    });
  }

  openLogin(userDetail: any) {
    this.isLogin = true;
    this.searchLoginObj.EkycClientcode = userDetail.ekycclientcode;

  this.searchLoginObj.Loginname = userDetail.loginName;

  this.loginWithChange('otp');

    

  }


  getTATDetails() {
    var ids = this.searchLoginObj.EkycClientcode;
    let url = "api/ClientDetails/getTATDetails/" + ids;
    this.webService.getData(url).toPromise().then(async (res: any) => {
      if (res != null) {
        debugger;
        let parseData = JSON.parse(JSON.stringify(res));
        console.log("tat", parseData.dataset[0]);
        if (parseData.dataset[0].isTATExpired == true) {
          this.isTATExpired = true;
        }
      }
    }, error => {

    });
  }

  resetSubmit() {
    this.searchLoginObj.Loginname = '';
    this.accountLists = [];
  }
		 handleSuccess(data) {
    console.log(data);
    this.enableLoginbutton = true;
  }		 
}
export class LoginObject {

  Loginname: string;
  Password: string;
  LoginOtp: number;
  EkycClientcode: string;
}



